import fetchServer from "../../../controllers/fetchServer";

export async function createWorldCup(data) {
  let result = {
    return: 0,
    msg: "Something went wrong creating World Cup game!",
  };

  await fetchServer({
    method: "POST",
    url: "/payment/v1/worldCup",
    data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: res?.data?.message || "World Cup game created successfully",
          data: res?.data?.data,
        };
      } else if (res?.data?.error) {
        result.msg = res.data.error;
      } else if (res?.data?.message) {
        result.msg = res.data.message;
      }
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}

export async function getWorldCupGames({ limit = 10, offset = 0 } = {}) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching World Cup games!",
    data: [],
  };

  await fetchServer({
    method: "GET",
    url: `/payment/v1/worldCup?limit=${limit}&offset=${offset}`,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: res?.data?.message || "Success",
          data: res?.data?.data ?? [],
        };
      } else if (res?.data?.error) {
        result.msg = res.data.error;
      } else if (res?.data?.message) {
        result.msg = res.data.message;
      }
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}

export async function settleWorldCup(id, data) {
  let result = {
    return: 0,
    msg: "Something went wrong settling World Cup game!",
  };

  await fetchServer({
    method: "POST",
    url: `/payment/v1/worldCup/${id}/settle`,
    data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: res?.data?.message || "World Cup game settled successfully",
          data: res?.data?.data,
        };
      } else if (res?.data?.error) {
        result.msg = res.data.error;
      } else if (res?.data?.message) {
        result.msg = res.data.message;
      }
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}
